import { useContext, useEffect, useState } from "react";
import { StoreContext } from "../store/Store";
import { GlobalRefContext } from "../store/GlobalRefs";
import { actionTypes } from "../store/storeTypes";
export const ControlPopupMenu = () => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { controlPopupMenu, dimensions, scrollTop } = store;
  const [popupStyle, setPopupStyle] = useState();

  const setShowPopup = (val) => {
    dispatch({
      type: actionTypes.SET_CONTROL_POPUP_MENU,
      payload: { ...controlPopupMenu, showPopup: val },
    });
  };

  useEffect(() => {
    if (
      controlPopupMenu.label &&
      controlPopupMenu.label in grefs.controlPositions.current
    ) {
      const maxHeight =
        dimensions.vh -
        grefs.controlPositions.current[controlPopupMenu.label].top -
        50 +
        scrollTop;

      const popupstyle = {
        position: "absolute",
        left: grefs.controlPositions.current[controlPopupMenu.label].left,
        top:
          grefs.controlPositions.current[controlPopupMenu.label].top +
          30 -
          scrollTop,
        border: "1px solid black",
        zIndex: 99999,
        backgroundColor: "#ffffff",
        display: "block",
        padding: 10,
        minWidth: grefs.controlPositions.current[controlPopupMenu.label].width,
        maxHeight: maxHeight,
        overflowY: "auto",
      };
      setPopupStyle(popupstyle);
    }
  }, [controlPopupMenu, dimensions, scrollTop, grefs.controlPositions]);

  const onClick = (val) => {

    if (controlPopupMenu.type[controlPopupMenu.label] === "checkbox") {
      let newSelection = controlPopupMenu.selected[controlPopupMenu.label];
      const index = newSelection.indexOf(val);
      if (index === -1) {
        //Add
        newSelection.push(val);
      } else {
        //remove
        newSelection.splice(index, 1);
      }
      val = newSelection;
    }
    dispatch({
      type: actionTypes.SET_CONTROL_POPUP_MENU,
      payload: {
        ...controlPopupMenu,
        showPopup: false,
        selected: {
          ...controlPopupMenu.selected,
          [controlPopupMenu.label]: val,
        },
      },
    });
  };

  const isChecked = (item) => {
    return controlPopupMenu.type[controlPopupMenu.label] === "radio"
      ? item.value === controlPopupMenu.selected[controlPopupMenu.label]
      : controlPopupMenu.selected[controlPopupMenu.label]
      ? controlPopupMenu.selected[controlPopupMenu.label].indexOf(
          item.value
        ) !== -1
      : false;
  };

  return controlPopupMenu.showPopup &&
    popupStyle &&
    controlPopupMenu.label in controlPopupMenu.menuItems ? (
    <div
      className="popupmenu"
      style={popupStyle}
      onMouseLeave={() => setShowPopup(false)}
    >
      {controlPopupMenu.menuItems[controlPopupMenu.label].map((item, i) => {
        return (
          <div key={i} style={{ display: "flex" }}>
            <input
              id={i}
              style={{ cursor: "pointer" }}
              type={controlPopupMenu.type[controlPopupMenu.label]}
              checked={isChecked(item)}
              onChange={() => onClick(item.value)}
            ></input>
            <div>{item.display}</div>
          </div>
        );
      })}
    </div>
  ) : null;
};
